/**
 * Modal para tratamento de erros durante o processamento
 */

import {
  Box,
  Modal,
  Paper,
  Typography,
  Button,
  Stack,
  IconButton,
  Alert,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ErrorIcon from '@mui/icons-material/Error';

export default function ErrorModal({ error, onRetry, onCancel }) {
  return (
    <Modal
      open={true}
      onClose={onCancel}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'rgba(0, 0, 0, 0.5)',
      }}
    >
      <Paper
        elevation={8}
        sx={{
          maxWidth: '500px',
          width: '90%',
          borderRadius: 3,
          position: 'relative',
        }}
      >
        {/* Close Button */}
        <IconButton
          onClick={onCancel}
          sx={{
            position: 'absolute',
            top: 12,
            right: 12,
            zIndex: 1,
          }}
        >
          <CloseIcon />
        </IconButton>

        {/* Content */}
        <Box sx={{ p: 4, textAlign: 'center' }}>
          {/* Error Icon */}
          <ErrorIcon
            sx={{
              fontSize: '4rem',
              color: '#f44336',
              mb: 2,
            }}
          />

          {/* Title */}
          <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 2 }}>
            Oops! Algo deu errado
          </Typography>

          {/* Error Message */}
          <Alert severity="error" sx={{ mb: 3, textAlign: 'left' }}>
            <Typography variant="body2">
              <strong>Erro:</strong> {error || 'Erro desconhecido ao processar onboarding'}
            </Typography>
          </Alert>

          {/* Description */}
          <Typography variant="body2" sx={{ color: 'text.secondary', mb: 3 }}>
            Não conseguimos completar a criação da sua estrutura. Você pode tentar novamente ou
            cancelar o onboarding.
          </Typography>

          {/* Action Buttons */}
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
            <Button
              onClick={onRetry}
              variant="contained"
              fullWidth
              sx={{
                py: 1.5,
                fontWeight: 600,
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              }}
            >
              Tentar Novamente
            </Button>

            <Button
              onClick={onCancel}
              variant="outlined"
              fullWidth
              sx={{
                py: 1.5,
                fontWeight: 600,
                color: '#f44336',
                borderColor: '#f44336',
                '&:hover': {
                  borderColor: '#d32f2f',
                  backgroundColor: 'rgba(244, 67, 54, 0.04)',
                },
              }}
            >
              Cancelar
            </Button>
          </Stack>
        </Box>
      </Paper>
    </Modal>
  );
}
